import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'modal-newsletter',
  templateUrl: './modal-newsletter.component.html',
  styleUrls: ['./modal-newsletter.component.scss']
})
export class ModalNewsletterComponent implements OnInit {
  showBanner: boolean = false;
  email: string = '';
  loading: boolean = false;
  success: boolean = false;
  error: string = '';

  constructor(
    private modal: ModalService,
    private genServ: EcommerceGenericoService
  ) { }

  ngOnInit(): void {
    // El flag mostrarNewsletter viene de la config del tenant, que todavía puede no
    // haber llegado en este punto (initmaster es asíncrono) — por eso se evalúa recién
    // al disparar el timer, no al momento de crear el componente.
    setTimeout(() => {
      if (this.genServ.getMostrarNewsletter()) {
        this.showBanner = true;
      }
    }, 5000);
  }

  async suscribir() {
    if (!this.email || !this.email.includes('@')) {
      this.error = 'Por favor, ingrese un email válido.';
      return;
    }

    this.loading = true;
    this.error = '';

    // Generamos un usuario con clave genérica y nivel específico (puse 9 como ejemplo)
    const genericPass = 'Newsletter2024!';
    const username = this.email.split('@')[0];
    const dummyDni = Math.floor(Math.random() * 10000000); // DNI random si no se pide
    const sucursal = this.genServ.getSucursalDefecto() || '81';

    this.genServ.crearUsuario(
      username,
      dummyDni,
      this.email,
      genericPass,
      sucursal,
      9 // Nivel Newsletter
    ).subscribe({
      next: () => {
        this.loading = false;
        this.success = true;
        setTimeout(() => {
          this.cerrar();
        }, 3000);
      },
      error: (err) => {
        this.loading = false;
        console.error('Error enviando newsletter', err);
        this.error = 'El email ya está registrado o hubo un problema. ¡Gracias!';
      }
    });
  }

  cerrar() {
    this.showBanner = false;
  }

}
